export default __webpack_public_path__ + "60ef0f7b090f8c22b75fa70ebc3e3c4d.wasm";